<template>
  <!--考试内容-->
  <div class="kaoshineirong">
    <h1 class="test_title">{{ testPaper.testpaperName }}</h1>
    <h2 class="test_des">
      本套试卷共{{ testPaper.subjectItems ? testPaper.subjectItems.length : 0 }}个题目，
      总分{{ examInfo.totalScore }}分，考试时间{{ examInfo.minute }} 分钟<span
        style="float: right; color: red"
        id="time"
        >剩余时间:{{ Math.floor(seconds / 60) }}分{{ Math.floor(seconds % 60) }}秒</span
      >
    </h2>
    <div class="test_main">
      <div
        class="subject_type"
        v-for="(category, categoryIndex) in subjectCategorys"
        :key="categoryIndex.name"
      >
        {{ category.name }}(共{{ category.timu.length }}题，每题{{
          category.totalScore > 0 ? category.totalScore / category.timu.length : 0
        }}
        分，共{{ category.totalScore }}分)
        <div class="shiti" v-for="(item, index) in category.timu" :key="index">
          <h4>{{ index + 1 }}.{{ item.subjectName }}</h4>

          <div class="test_item_main">
            <div v-if="item.subjectType == 3">
              <textarea
                rows="6"
                style="width: 90%"
                v-model="item.userAnswer"
                @change="
                  changeAnswer(
                    item.subjectId,
                    item.userAnswer,
                    item.subjectType,
                    item.userAnswer
                  )
                "
              />
            </div>

            <div
              class="selectItem"
              v-for="(option, optIndex) in item.options"
              :key="optIndex"
            >
              <p>
                <input
                  :checked="option.checked"
                  :type="item.subjectType == 1 ? 'checkbox' : 'radio'"
                  :value="option.title"
                  :name="category.type + index"
                  :data="item.subjectId"
                  v-model="item.userAnswer"
                  @click="
                    changeAnswer(
                      item.subjectId,
                      option.title,
                      item.subjectType,
                      item.userAnswer
                    )
                  "
                />{{ option.title }}.{{ option.answer }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a href="javascript:;" class="ex_btn" @click="submitExamination()">提交试卷</a>
    <a href="javascript:;" style="display: none" class="back_btn">返回</a>
  </div>
</template>
import { parseDate } from '@libs/tools'
<script>
export default {
  data() {
    return {
      sumbitData: [],
      recordId: "",
      examData: [],
      seconds: 0,
      timer: null,
      examId: "",
      subjectIds: "",
      testPaper: {},
      examInfo: {},
      examData: [],
      questionsCount: "",
      subjectCategorys: [
        {
          name: "一、单选题",
          timu: [],
          type: "danxuan",
          totalScore: 0,
        },
        {
          name: "二、多选题",
          timu: [],
          type: "duoxuan",
          totalScore: 0,
        },
        {
          name: "三、判断题",
          timu: [],
          type: "panduan",
          totalScore: 0,
        },
        {
          name: "四、主观题",
          timu: [],
          type: "zhuguan",
          totalScore: 0,
        },
      ],
      sindex1: 1,
      sindex2: 1,
      sindex3: 1,
    };
  },
  created() {
    if (this.$route.query.examId) {
      this.examId = this.$route.query.examId;
      this.startExamination();
    }
  },
  methods: {
    beginTimer() {
      let _this = this;
      _this.timer = setInterval(function () {
        if (_this.seconds <= 0) {
          clearInterval(_this.timer);
          _this.submitExamination();
          return;
        }
        if (_this.seconds === 900) {
          _this.$modal.alertWarning("距离考试结束还有15分钟！");
        }
        _this.seconds--;
      }, 1000);
    },
    submitExamination() {
      let _this = this;
      let subjectIdList = [];
      subjectIdList.push(_this.subjectIds);
      console.log("subjectIdList", subjectIdList.length);
      // if (subjectIdList.length < _this.examData.length) {
      //   _this.$modal.alertError("仍有考题还未作答,请确认是否交卷？");
      //   return;
      // }
      layer.load(3, {
        shade: 0.3,
        content: "考试结束，试卷正在提交...",
        success: function (layero) {
          layero.find(".layui-layer-content").css({
            paddingTop: "40px",
            width: "200px",
            "font-size": "15px",
            color: "white",
            textAlign: "center",
            backgroundPositionX: "center",
          });
        },
      });
      let params = {
        recordId: _this.recordId,
      };
      _this.$api.examination
        .submitExamination(params)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            layer.closeAll();
            _this.$router.push({
              name: "examResult",
              query: { recordId: _this.recordId },
            });
            // _this.examination = res.data;
          }
        })
        .catch(() => {})
        .finally(() => {
          layer.closeAll();
        });
    },
    changeAnswer(subjectId, answer, subjectType, obj) {
      let _this = this;
      if (subjectType == 1) {
        //如果已经选中了，那就取消选中，如果没有，则选中
        if (obj.length > 0 && obj.indexOf(answer) >= 0) {
          obj = obj.filter((item) => item != answer);
        } else {
          obj.push(answer);
        }
      } else {
        obj = answer;
      }
      let parmas = {
        recordId: _this.recordId,
        subjectId: subjectId,
        answer: subjectType == 1 ? obj.join(",") : obj,
        type: "examination",
      };
      _this.subjectIds = subjectId;
      _this.$api.examination
        .answerProcess(parmas)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            // _this.examination = res.data;
          }
        })
        .catch(() => {});
    },
    startExamination() {
      let _this = this;
      let parmas = {
        examinationId: _this.examId,
        type: 2,
      };
      _this.$api.examination
        .startExamination(parmas)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            console.log("res", res.data);
            _this.recordId = res.data.recordId;
            _this.testPaper = res.data.testPaper;
            _this.examInfo = res.data;
            // if (res.data.subjects && res.data.subjects.length == 0) {
            //   layer.alert("暂无考试", function (index) {
            //     window.history.back();
            //     layer.close(index);
            //   });
            // }
            _this.examData = res.data.testPaper.subjectItems;
            for (var i = 0; i < _this.examData.length; i++) {
              let item = _this.examData[i];
              let index = 0;
              if (item.subjectType == 0) {
                index = _this.sindex1++;
              } else if (item.subjectType == 1) {
                index = _this.sindex2++;
              } else {
                index = _this.sindex3++;
              }
              let thisOptine = JSON.parse(item.optionConf);
              console.log("thisop", thisOptine);
              if (item.subjectType == 1) {
                item.userAnswer = [];
              } else {
                item.userAnswer = "";
              }
              let answer = [];
              if (res.data.userAnswer && res.data.userAnswer.length > 0) {
                for (var j = 0; j < res.data.userAnswer.length; j++) {
                  let answer = res.data.userAnswer[j];
                  if (answer.subjectId == item.subjectId) {
                    if (item.subjectType == 1) {
                      item.userAnswer = answer.answer.split(",");
                    } else {
                      item.userAnswer = answer.answer;
                    }
                  }
                }
              }
              console.log("item", item.userAnswer);
              item.options = thisOptine;
              if (item.subjectType == 0) {
                _this.subjectCategorys[0].timu.push(item);
                _this.subjectCategorys[0].totalScore += item.score;
                // _this.t1.push(item);
                // _this.score1 += item.score;
              } else if (item.subjectType == 1) {
                _this.subjectCategorys[1].timu.push(item);
                _this.subjectCategorys[1].totalScore += item.score;
                // _this.t2.push(item);
                // _this.score2 += item.score;
              } else if (item.subjectType == 2) {
                _this.subjectCategorys[2].timu.push(item);
                _this.subjectCategorys[2].totalScore += item.score;
                // _this.t3.push(item);
                // _this.score3 += item.score;
              } else {
                _this.subjectCategorys[3].timu.push(item);
                _this.subjectCategorys[3].totalScore += item.score;
              }
            }
            var startTime = new Date(res.data.startTime);
            var nowTime = new Date();
            console.log("startTime", startTime);
            var Hours = nowTime.getHours() - startTime.getHours();
            var Minutes = nowTime.getMinutes() - startTime.getMinutes();
            var Seconds = nowTime.getSeconds() - startTime.getSeconds();

            _this.questionsCount = res.data.questionsCount;

            this.seconds =
              res.data.minute * 60 - Hours * 60 * 60 - Minutes * 60 - Seconds;

            // // 考试已用时间，中途退出继续考试时，减去已用时间
            // var usedSecond = Number(res.data.usedSecond);
            // this.seconds -= usedSecond;
            //考试倒计时
            this.beginTimer();
          } else {
            _this.$layer.alert(res.msg, { icon: 1, closeBtn: 0 }, function (index) {
              window.history.go(-1);
              _this.$layer.close(index);
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/exam/examTest.vue